import { ReturnRequest, ReturnRequestStatus, ReturnRequestStatusValue, ReturnStatusHelper } from '@/app/shared/interface/order.interface';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Product} from "@/app/shared/interface/product.interface";
import {ProductService} from "@/app/shared/services/product.service";

@Component({
  selector: 'app-return-order-list',
  templateUrl: './return-order-list.component.html',
  styleUrl: './return-order-list.component.scss'
})
export class ReturnOrderListComponent implements  OnChanges {
  public ReturnRequestStatusValue = ReturnRequestStatusValue;
  public ReturnRequestStatus = ReturnRequestStatus;
  @Input() returnOrders: ReturnRequest[] = [];

  public detail: ReturnRequest | undefined;
  public productMap: Record<string, Product> = {};

  constructor(
    private productService: ProductService
  ) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['returnOrders'] && this.returnOrders?.length) {
      this.loadProductsBySkus();
    }
  }

  getStatusClass(status: ReturnRequestStatus): string {
    return ReturnStatusHelper.getClass(status);
  }

  viewDetail(data: ReturnRequest) {
    this.detail = data;
  }

  private loadProductsBySkus(): void {
    const allSkus = this.returnOrders
      .flatMap(req => req.items)
      .flatMap(order => order.items)
      .map(item => item.productSku)
      .filter((sku, i, arr) => sku && arr.indexOf(sku) === i);

    if (!allSkus.length) return;

    const body = JSON.stringify({ productSkus: allSkus });

    this.productService.getProductsForMember(body).subscribe({
      next: (res) => {
        const products = (res as any)?.products || (res as any)?.data?.products || [];

        this.productMap = products.reduce((acc: any, product: any) => {
          if (product.sku) acc[product.sku] = product;
          if (product.skU2) acc[product.skU2] = product;
          return acc;
        }, {} as Record<string, Product>);

      },
      error: (err) => {
        console.error('Failed to load products', err);
      }
    });
  }

  getProductInfo(sku: string): Product | undefined {
    return this.productMap[sku];
  }



}
